module.exports = __webpack_public_path__ + "static/img/四层.de72613.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics/四层.png
// module id = hLmJ
// module chunks = 0